import { api } from "../api/axios";

export const FeePresetService = {
  getPresets: async (params) => {
    const { data } = await api.get("/fee-presets", { params });
    return data;
  },

  createPreset: async (payload) => {
    const { data } = await api.post("/fee-presets", payload);
    return data;
  },

  deletePreset: async (id) => {
    const { data } = await api.delete(`/fee-presets/${id}`);
    return data;
  },

  bulkUploadCsv: async (payload) => {
    const { data } = await api.post("/fee-presets/bulk-csv", payload);
    return data;
  },

  copyFromPrevious: async (payload) => {
    const { data } = await api.post("/fee-presets/copy", payload);
    return data;
  },
};
